<template>
  <v-dialog
    v-model="dialog"
    max-width="1024"
    persistent
  >
    <v-card>
      <v-card-title
        primary-title
        class="text-uppercase light-blue darken-4 white--text"
      >
        <v-icon
          color="white"
          class="mr-2"
        >
          notification_important
        </v-icon>
        Potential Duplicates Detected
      </v-card-title>

      <v-container>
        <Duplicates
          :duplicates="duplicates"
        />
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="onProceed"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Duplicates from '@/components/Party/Duplicates.vue'

export default {
  name: 'PEPartyDuplicatesDialog',

  components: {
    Duplicates,
  },

  props: {

    duplicates: {
      type: Array,
      required: true,
    },

    onProceed: {
      type: Function,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },

    hasDuplicates () { return this.duplicates.length > 0 },

  },

}
</script>
